import currentUserManager from './currentUserManager/currentUserManager'
import deleteUserManager from './css-admin/deleteUser/deleteUserManager'
import licenseManager from './css-admin/licenseManager/licenseManager'
import lmsManager from './css-admin/lmsManager/lmsManager'
import mergeManager from './css-admin/merge/mergeManager'
import modal from './modal'
import notifications from './notifications'
import pacingManager from './css-admin/pacing/reducer'
import refData from './css-admin/refData/refData'
import reportsManager from './reports'
import rosterManager from './css-admin/roster/rosterManager'
import sitePreferencesManager from './css-admin/sitePreferences/sitePreferencesManager'
import sitesManager from './sitesManager'
import subscriptionManager from './css-admin/subscriptionManager/subscriptionManager'
import userManager from './css-admin/userManager/userManager'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

const rootReducer = history =>
  combineReducers({
    currentUserManager,
    deleteUserManager,
    licenseManager,
    lmsManager,
    mergeManager,
    modal,
    notifications,
    pacingManager,
    refData,
    reportsManager,
    rosterManager,
    router: connectRouter(history),
    sitePreferencesManager,
    sitesManager,
    subscriptionManager,
    userManager,
  })

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/reducers.js